// react
import styled from 'styled-components';

// components
import { Card, Container, Icon, Title } from '@/components/atoms';
import { FloatingActions } from '@/components/molecules';

interface PoaSuccessProps {
  className?: string;
}

/**
 * PoaSuccess renders the success screen when a user has successfully
 * applied for POA.
 */
export const PoaSuccess = ({ className }: PoaSuccessProps) => {
  return (
    <Container className={className}>
      <Wrapper>
        <Title>Power of Attorney</Title>
        <IconWrapper>
          <Icon icon='check' fontSize={24} />
        </IconWrapper>
        <SubTitle>Payment Successful</SubTitle>
        <Description>
          You have successfully purchased your Power of Attorney through Zenco!
        </Description>
        <Card color='blue' elevation={0} isBordered={false} isPaddingSm>
          <CardTitle>Your next steps</CardTitle>
          <CardUL>
            <li>Click below to return to our app’s Home Screen</li>
            <li>
              Need help? Contact us at{' '}
              <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>
                {process.env.REACT_APP_SUPPORT_EMAIL}
              </a>
            </li>
          </CardUL>
        </Card>
      </Wrapper>
      <FloatingActions
        actions={[
          {
            label: 'Return Home',
            to: '/',
          },
        ]}
      />
    </Container>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.theme.spacing[16]};
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 99999px;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
  background: ${(props) => props.theme.color.success[40]};
  color: ${(props) => props.theme.color.neutral[10]};
`;

const SubTitle = styled.div`
  font: ${(props) => props.theme.typography.heading['3xl']};
  color: ${(props) => props.theme.color.neutral[100]};
`;

const Description = styled.div`
  font: ${(props) => props.theme.typography.body.md.regular};
  color: ${(props) => props.theme.color.neutral[90]};
`;

const CardTitle = styled.div`
  font: ${(props) => props.theme.typography.body.lg.medium};
  color: ${(props) => props.theme.color.neutral[90]};
`;

const CardUL = styled.ul`
  list-style-type: disc;
  padding-left: ${(props) => props.theme.spacing[16]};

  & a {
    color: ${(props) => props.theme.color.primary[30]};
  }

  & > li {
    padding-bottom: ${(props) => props.theme.spacing[16]};
  }

  & > li:last-child {
    padding-bottom: 0;
  }
`;

PoaSuccess.displayName = 'PoaSuccess';

export default PoaSuccess;
